import Vue from 'vue'
import ElSelectTree from 'el-select-tree';

Vue.use(ElSelectTree);